export const paymentPartnerAlertNotes = [
  "The linked lender associated with the current company will be removed.",
  "Employees will no longer be able to withdraw funds.",
  "Employees synchronization will stop functioning.",
];

export const WEBHOOK_ENABLED_SYSTEMS = ["WAGELOCH"]